
import BarcodeHandlerMixin, { BarcodeParseResult } from '@/components/mixins/BarcodeHandlerMixin.vue'
import {
  CodeTypeSetting,
  ConfigId,
  KeyenceModule,
  ScanResult,
  defaultCodeTypeSetting,
  isKeyenceEnterpriseBrowser,
} from '@/utils/keyenceHT/keyenceModules'
import { Options, mixins } from 'vue-class-component'
import { PropSync } from 'vue-property-decorator'
import IconScanQR from '../svg/IconScanQR.vue'
import { openMessage } from '@/utils/helpers'
import { SAVE_SCANNED_WORK_CENTER_CODE } from '../../store/actions'

@Options({
  components: {
    IconScanQR,
  },
})
export default class ScanButton extends mixins(BarcodeHandlerMixin) {
  @PropSync('loading', { type: Boolean }) _loading!: boolean
  backupCodeTypeSetting: CodeTypeSetting = defaultCodeTypeSetting

  get isEnterpriseBrowser(): boolean {
    return isKeyenceEnterpriseBrowser()
  }

  async mounted() {
    if (isKeyenceEnterpriseBrowser() && KeyenceModule && KeyenceModule.Scanner) {
      this.backupCodeTypeSetting = KeyenceModule.Scanner.getConfig(ConfigId.CodeType) as CodeTypeSetting
      KeyenceModule.Scanner.setConfig(ConfigId.CodeType, defaultCodeTypeSetting)

      KeyenceModule.Scanner.clearReadCallback()
      KeyenceModule.Scanner.setReadCallback('keyenceHandyTerminalScanResultCallback')
    }

    window.keyenceHandyTerminalScanResultCallback = (result: ScanResult) => {
      if (result.mDecodeResult !== 'SUCCESS') {
        return
      }
      const resultString =
        typeof result.mStringData === 'string' ? result.mStringData : result.mStringData[0].toString()

      this._loading = true
      this.processScannedText(resultString)
    }
  }

  handleBarcodeResult(result: BarcodeParseResult) {
    if (result.isNewFormat || result.isOldFormat) {
      this.$store.dispatch(SAVE_SCANNED_WORK_CENTER_CODE, '')
      const params = result.isNewFormat
        ? { barcodeId: result.barcodeId }
        : { barcodeId: result.barcodeId, project: result.projectId }
      this.$router.push({ name: 'detail', params, query: { openWorkCenter: 'true' } })
    } else {
      const readingError = `${this.$t('reading_error1')}${this.$t('reading_error2')}${this.$t('reading_error3')}`
      openMessage(readingError, 'warning')
      this._loading = false
    }
  }

  async unmounted() {
    if (isKeyenceEnterpriseBrowser() && KeyenceModule && KeyenceModule.Scanner) {
      KeyenceModule.Scanner.setConfig(ConfigId.CodeType, this.backupCodeTypeSetting)
    }
  }

  async startScan() {
    KeyenceModule.Scanner.startRead()
  }
}
